import React, { useEffect, useState, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import query, { get } from "jquery";
import { Link, NavLink, useLocation } from "react-router-dom";
import {
  getCategories,
  getSubCategories,
  getAllCollections,
  searchProductsSuggestions,
} from "../services/nonAuthRequets";
import { testGet } from "../services/authenticatedRequests";
import ProductListOne from "./ProductListOne";
import Logo from "../assets/images/logo/bigmall-logo.png";
import { useCart } from "../contexts/CartContext";
import { AuthContext } from "../contexts/AuthContext";
import { useWishlist } from "../contexts/WishlistContext";
import "../assets/css/dropdown.css";
import AppModal from "./AppModal";
import MobileBanner from "./MobileBanner";
import MobileViewBottomNav from "./MobileViewBottomNav";
import "../assets/css/suggestions-dropdown.css";
import { S3_URL_PRODUCTS } from "../utils/constants";

const HeaderOne = () => {
  const { isAuthenticated, logout, user } = useContext(AuthContext);
  const currentTab = useLocation();
  const [scroll, setScroll] = useState(false);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [isSubmenuOpen, setIsSubmenuOpen] = useState(false);
  const { cartCount } = useCart();
  const [testResponse, setTestResponse] = useState(null);
  const { wishlistCount } = useWishlist();
  const [collections, setCollections] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const containerRef = useRef(null);

  const handleModalOpen = () => {
    setIsModalOpen(true);
  };
  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const handleSearchSubmit = (event) => {
    event.preventDefault();
    const query = event.target.search.value.trim();
    if (query) {
      navigate(`/search?query=${encodeURIComponent(query)}`);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setShowSuggestions(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  useEffect(() => {
    const fetchSuggestions = async () => {
      if (searchQuery.trim()) {
        try {
          const results = await searchProductsSuggestions(searchQuery, 0, 6);
          console.log("Search results:", results);
          setSuggestions(results.content);
        } catch (error) {
          console.error("Error fetching suggestions:", error);
        }
      }
    };

    const debounceTimer = setTimeout(fetchSuggestions, 300);
    return () => clearTimeout(debounceTimer);
  }, [searchQuery]);
  const handleSearchSubmitMobile = (event) => {
    event.preventDefault();
    const query = event.target.search.value.trim();
    if (query) {
      navigate(`/search?query=${encodeURIComponent(query)}`);
      handleSearchToggle();
    }
  };
  const fetchCategories = async () => {
    try {
      const data = await getCategories();
      setCategories(data.content);
    } catch (error) {
      console.error("Error fetching categories:", error);
    } finally {
      setLoading(false);
    }
  };
  const fetchSubCategories = async (id) => {
    try {
      setLoading(true);
      const data = await getSubCategories(id);
      //console.log("Sub Categories:", data);
      setSubCategories(data);
    } catch (error) {
      console.error("Error fetching sub categories:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchCollections = async () => {
    const data = await getAllCollections();
    // console.log("Collections:", data);
    setCollections(data.content);
  };

  // const test = async () => {
  //   try {
  //     // only trigger the request if the user is authenticated
  //     if (isAuthenticated) {
  //       const data = await testGet();
  //       setTestResponse(data);
  //      // console.log("Test data:", data);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching test data:", error);
  //   }
  // };

  useEffect(() => {
    fetchCategories();
    //test();
    fetchCollections();
    //handleWishlistCount();
  }, []);
  useEffect(() => {
    window.onscroll = () => {
      if (window.pageYOffset < 150) {
        setScroll(false);
      } else if (window.pageYOffset > 150) {
        setScroll(true);
      }
      return () => (window.onscroll = null);
    };
    const selectElement = query(".js-example-basic-single");
    selectElement.select2();

    return () => {
      if (selectElement.data("select2")) {
        selectElement.select2("destroy");
      }
    };
  }, []);

  // Set the default language
  const [selectedLanguage, setSelectedLanguage] = useState("Eng");
  const handleLanguageChange = (language) => {
    setSelectedLanguage(language);
  };

  // Set the default currency
  const [selectedCurrency, setSelectedCurrency] = useState("USD");
  const handleCurrencyChange = (currency) => {
    setSelectedCurrency(currency);
  };

  // Mobile menu support
  const [menuActive, setMenuActive] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);
  const handleMenuClick = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  const handleMenuToggle = () => {
    // alert('clicked');
    setMenuActive(!menuActive);
    // setMenuActive((prev) => {
    //   console.log("Previous state:", prev);
    //   return !prev;
    // });
  };
  const handleMenuToggleMobile = () => {
    setMenuActive((prev) => !prev);
  };

  // Search control support
  const [activeSearch, setActiveSearch] = useState(false);
  const handleSearchToggle = () => {
    setActiveSearch(!activeSearch);
  };

  // category control support
  const [activeCategory, setActiveCategory] = useState(false);
  const handleCategoryToggle = () => {
    setActiveCategory(!activeCategory);
  };
  const [activeIndexCat, setActiveIndexCat] = useState(null);
  const handleCatClick = (index) => {
    setActiveIndexCat(activeIndexCat === index ? null : index);
  };

  let timeoutId;

  const handleMouseEnter = (index, categoryId) => {
    clearTimeout(timeoutId);
    setIsSubmenuOpen(true);

    timeoutId = setTimeout(async () => {
      if (activeIndexCat !== index) {
        setActiveIndexCat(index);
        setLoading(true);

        try {
          await fetchSubCategories(categoryId);
        } catch (error) {
          console.error("Error fetching subcategories:", error);
        } finally {
          setLoading(false);
        }
      }
    }, 300); // Add a 300ms delay before fetching
  };

  const handleMouseLeave = () => {
    setTimeout(() => {
      if (!isSubmenuOpen) {
        setActiveIndexCat(null);
        setSubCategories([]);
      }
    }, 300); // Add a delay to allow moving to submenu
  };
  const hasCollections = collections && collections.length > 0;

  const hotDealCollection = collections?.find(
    (collection) => collection.type && collection.type === "Hot_Deals"
  );

  return (
    <>
      <div className="overlay" />
      <div
        className={`side-overlay ${(menuActive || activeCategory) && "show"}`}
      />

      {/* ==================== Search Box Start Here ==================== */}

      {/* <form
        className={`search-box-custom ${activeSearch && "active"}`}
        onSubmit={handleSearchSubmitMobile}
      >
        <button
          onClick={handleSearchToggle}
          type="button"
          className="search-box-custom__close position-absolute inset-block-start-0 inset-inline-end-0 m-16 w-48 h-48 bg-gray-200 border border-gray-400 rounded-circle flex-center text-gray-800 shadow-md hover-text-black hover-bg-gray-300 text-2xl transition-1"
        >
          <i className="ph ph-x" />
        </button>
        <div className="container">
          <div className="position-relative">
            <input
              type="text"
              className="form-control py-16 px-24 text-xl rounded-pill pe-64"
              placeholder="Search for products"
              name="search"
            />
            <button
              type="submit"
              className="w-48 h-48 bg-main-600 rounded-circle flex-center text-xl text-white position-absolute top-50 translate-middle-y inset-inline-end-0 me-8"
            >
              <i className="ph ph-magnifying-glass" />
            </button>
          </div>
        </div>
      </form> */}
      <form
        className={`search-box-custom ${activeSearch && "active"}`}
        onSubmit={handleSearchSubmitMobile}
        ref={containerRef} // Add ref here for click-outside detection
      >
        <button
          onClick={handleSearchToggle}
          type="button"
          className="search-box-custom__close position-absolute inset-block-start-0 inset-inline-end-0 m-16 w-48 h-48 bg-gray-200 border border-gray-400 rounded-circle flex-center text-gray-800 shadow-md hover-text-black hover-bg-gray-300 text-2xl transition-1"
        >
          <i className="ph ph-x" />
        </button>
        <div className="container">
          <div className="position-relative">
            <input
              type="text"
              className="form-control py-16 px-24 text-xl rounded-pill pe-64"
              placeholder="Search for products"
              name="search"
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                setShowSuggestions(true);
              }}
              autoComplete="off"
            />
            <button
              type="submit"
              className="w-48 h-48 bg-main-600 rounded-circle flex-center text-xl text-white position-absolute top-50 translate-middle-y inset-inline-end-0 me-8"
            >
              {loading ? (
                <i className="ph ph-spinner animate-spin" />
              ) : (
                <i className="ph ph-magnifying-glass" />
              )}
            </button>
          </div>

          {/* Suggestions Dropdown for Mobile */}
          {showSuggestions && searchQuery && suggestions && (
            <div className="suggestions-dropdown position-absolute w-100 bg-white shadow mt-1 rounded">
              <ul className="list-unstyled mb-0">
                {suggestions.map((product) => (
                  <li
                    key={product.id}
                    className="px-3 py-2 cursor-pointer hover-bg-light d-flex align-items-center"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      navigate(
                        `/product-details/${encodeURIComponent(product.id)}`
                      );
                      setShowSuggestions(false);
                    }}
                  >
                    {product.images?.length > 0 && (
                      <img
                        src={`${S3_URL_PRODUCTS}${product.images[0]}`}
                        alt={product.name}
                        className="img-fluid me-2"
                        style={{ width: "40px", height: "40px" }}
                      />
                    )}
                    {product.name}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </form>

      {/* ==================== Search Box End Here ==================== */}
      {/* ==================== Mobile Menu Start Here ==================== */}
      <div
        style={{ display: "none" }}
        className={`mobile-menu scroll-sm d-lg-none d-block ${
          menuActive && "active"
        }`}
      >
        <button
          onClick={() => {
            handleMenuToggle();
            setActiveIndex(null);
          }}
          type="button"
          className="close-button"
        >
          <i className="ph ph-x" />{" "}
        </button>

        <div className="mobile-menu__inner">
          <Link to="/" className="mobile-menu__logo">
            <img src={Logo} alt="Logo" />
          </Link>
          <div className="mobile-menu__menu">
            {/* Nav Menu Start */}
            <ul className="nav-menu flex-align nav-menu--mobile">
              {/* Home Menu */}

              <li className="on-hover-item nav-menu__item">
                <Link to="/" className="nav-menu__link">
                  Home
                </Link>
              </li>

              {/* <li className="on-hover-item nav-menu__item">
                <Link to="/products" className="nav-menu__link">
                  {" "}
                  Products
                </Link>
              </li> */}
              <li className="on-hover-item nav-menu__item">
                {hasCollections ? (
                  <div className="dropdown">
                    {/* Dropdown toggle – no active styling needed here */}
                    <a
                      className="nav-menu__link dropdown-toggle"
                      href="#"
                      id="productsDropdown"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      Products
                    </a>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="productsDropdown"
                    >
                      {collections
                        .filter(
                          (collection) => collection.displayName !== "Hot Deals"
                        )
                        .map((collection) => {
                          if (collection.status !== "active") return null;
                          const collectionLink = `/${collection.type.toLowerCase()}/${
                            collection.collectionId
                          }`;
                          return (
                            <li key={collection.collectionId}>
                              <NavLink
                                to={collectionLink}
                                className="dropdown-item"
                              >
                                {collection.displayName}
                              </NavLink>
                            </li>
                          );
                        })}
                      <li>
                        <NavLink to="/products" className="dropdown-item">
                          All Products
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                ) : (
                  <Link to="/products" className="nav-menu__link">
                    Products
                  </Link>
                )}
              </li>

              {isAuthenticated ? (
                <li className="nav-menu__item">
                  <Link
                    to="/my-orders"
                    className="nav-menu__link"
                    onClick={() => setActiveIndex(null)}
                  >
                    My Orders
                  </Link>
                </li>
              ) : (
                <li className="nav-menu__item">
                  <Link
                    to="/track-order"
                    className="nav-menu__link"
                    onClick={() => setActiveIndex(null)}
                  >
                    Track Order
                  </Link>
                </li>
              )}

              {/* Contact Us Menu */}
              <li className="nav-menu__item">
                <Link
                  to="/contact"
                  className="nav-menu__link"
                  onClick={() => setActiveIndex(null)}
                >
                  Contact Us
                </Link>
              </li>
              <li className="on-hover-item nav-menu__item">
                {/* <span className="badge-notification bg-main-600 text-white text-sm py-2 px-8 rounded-4">
                  🔥
                </span> */}
                <Link
                  to={
                    hotDealCollection
                      ? `/hotdeals/${hotDealCollection.collectionId}`
                      : "/hotdeals"
                  }
                  className="nav-menu__link"
                >
                  {hotDealCollection
                    ? hotDealCollection.displayName
                    : "Hot Deals"}
                </Link>
              </li>
            </ul>
            <div className="text-center mt-4">
              <button
                className="btn btn-outline-main d-flex align-items-center"
                onClick={handleModalOpen}
              >
                <i className="bi bi-phone fs-1 text-main"></i>
                <span className="ms-2 fw-bold">Get Big Mall App</span>
              </button>
            </div>
            {/* Nav Menu End */}
          </div>
        </div>
      </div>
      {/* ==================== Mobile Menu End Here ==================== */}
      {/* ======================= Middle Top Start ========================= */}
      <div
        className="header-top bg-main-600 flex-between"
        style={{ display: "block" }}
      >
        <div className="container container-lg">
          <div className="flex-between flex-wrap gap-8">
            <ul className="flex-align flex-wrap">
              {/* <li className="border-right-item d-none d-md-block">
                <Link
                  to="#"
                  className="text-white text-sm hover-text-decoration-underline d-flex"
                >
                  Become A Seller
                </Link>
              </li> */}
              <li className="border-right-item d-none d-md-block">
                <Link
                  to="/about-us"
                  className="text-white text-sm hover-text-decoration-underline"
                >
                  About Us
                </Link>
              </li>

              <li className="border-right-item d-none d-md-block">
                <Link
                  to="/return-policy"
                  className="text-white text-sm hover-text-decoration-underline"
                >
                  Refund & Returns Policy
                </Link>
              </li>
            </ul>
            <ul className="header-top__right flex-align flex-wrap">
              {/* <li className="on-hover-item border-right-item border-right-item-sm-space has-submenu arrow-white">
                <Link to="#" className="text-white text-sm py-8">
                  Help Center
                </Link>

                <ul className="on-hover-dropdown common-dropdown common-dropdown--sm max-h-200 scroll-sm px-0 py-8">
                  <li className="nav-submenu__item">
                    <Link
                      to="#"
                      className="nav-submenu__link hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0"
                    >
                      <span className="text-sm d-flex">
                        <i className="ph ph-headset" />
                      </span>
                      Call Center
                    </Link>
                  </li>
                  <li className="nav-submenu__item">
                    <Link
                      to="#"
                      className="nav-submenu__link hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0"
                    >
                      <span className="text-sm d-flex">
                        <i className="ph ph-chat-circle-dots" />
                      </span>
                      Live Chat
                    </Link>
                  </li>
                </ul>
              </li> */}
              {isAuthenticated ? (
                <>
                  {/* My Account Link */}
                  <li className="border-right-item">
                    <Link
                      to="/account"
                      className="text-white text-sm py-8 flex-align gap-6"
                    >
                      <span className="icon text-md d-flex">
                        <i className="ph ph-user-circle" />
                      </span>
                      <span className="hover-text-decoration-underline">
                        <span>{user?.displayName ?? user?.username}</span>
                      </span>
                    </Link>
                  </li>

                  {/* Logout Button */}
                  <li className="border-right-item">
                    <button
                      onClick={logout}
                      className="text-white text-sm py-8 flex-align gap-6 bg-transparent border-0 cursor-pointer"
                    >
                      <span className="icon text-md d-flex">
                        <i className="ph ph-sign-out" />
                      </span>
                      <span className="hover-text-decoration-underline">
                        Logout
                      </span>
                    </button>
                  </li>
                </>
              ) : (
                /* Login Link */
                <li className="border-right-item">
                  <Link
                    to="/login"
                    className="text-white text-sm py-8 flex-align gap-6"
                  >
                    <span className="icon text-md d-flex">
                      <i className="ph ph-user-circle" />
                    </span>
                    <span className="hover-text-decoration-underline">
                      Login/Register
                    </span>
                  </Link>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>
      {/* ======================= Middle Top End ========================= */}
      {/* ======================= Middle Header Start ========================= */}
      {/* <header
        className={`header bg-white border-bottom border-gray-100 ${
          scroll && "fixed-header"
        }`}
      ></header> */}
      <header
        className={`header-middle bg-color-white border-bottom border-gray-100 
         ${scroll && "fixed-header"}`}
      >
        <MobileBanner />
        <div className="container container-lg">
          <nav className="header-inner flex-between">
            {/* Logo Start */}
            <div className="max-w-120 ms-16 d-none d-md-block">
              <Link to="/" className="link">
                <img src={Logo} alt="Logo" />
              </Link>
            </div>

            {/* Logo End  */}

            <form
              onSubmit={handleSearchSubmit}
              className="flex-align flex-wrap form-location-wrapper"
            >
              <div
                className="search-category position-relative d-flex h-48 select-border-end-0 radius-end-0 search-form d-sm-flex d-none"
                style={{ display: "block" }}
                ref={containerRef}
              >
                <div className="search-form__wrapper position-relative">
                  <input
                    type="text"
                    name="search"
                    className="search-form__input common-input py-13 ps-16 pe-18 rounded-pill pe-44"
                    placeholder="Search for products"
                    value={searchQuery}
                    onChange={(e) => {
                      setSearchQuery(e.target.value);
                      setShowSuggestions(true);
                    }}
                    autoComplete="off"
                  />
                  <button
                    type="submit"
                    className="w-32 h-32 bg-main-600 rounded-circle flex-center text-xl text-white position-absolute top-50 translate-middle-y inset-inline-end-0 me-8"
                  >
                    {loading ? (
                      <i className="ph ph-spinner animate-spin" />
                    ) : (
                      <i className="ph ph-magnifying-glass" />
                    )}
                  </button>
                </div>
                {showSuggestions && searchQuery && suggestions && (
                  <div className="suggestions-dropdown">
                    <ul className="list-unstyled mb-0">
                      {suggestions.map((product) => (
                        <li
                          key={product.id}
                          className="px-3 py-2 cursor-pointer hover-bg-light"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation(); // Add this
                            console.log(
                              "Attempting navigation with product ID:",
                              product.id
                            );
                            navigate(
                              `/product-details/${encodeURIComponent(
                                product.id
                              )}`
                            );
                            setShowSuggestions(false);
                          }}
                        >
                          {product.images?.length > 0 && (
                            <img
                              src={`${S3_URL_PRODUCTS}${product.images[0]}`}
                              alt={product.name}
                              className="img-fluid me-2"
                              style={{ width: "40px", height: "40px" }}
                            />
                          )}
                          {product.name}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </form>

            {/* <div className="text-center d-none d-md-block ">
              <p>{testResponse}</p>
            </div> */}

            {/* form location start */}
            {/* Header Middle Right start */}
            <div className="header-right flex-align d-lg-block d-none">
              <div className="flex-align flex-wrap gap-12">
                <button
                  className="btn btn-sm btn-outline-main flex-align align-items-center"
                  onClick={handleModalOpen}
                >
                  <i className="bi bi-phone fs-4 text-main"></i>
                  <span className="ms-2 fw-bold">Get Big Mall App</span>
                </button>
                <button
                  type="button"
                  className="search-icon flex-align d-lg-none d-flex gap-4 item-hover"
                >
                  <span className="text-2xl text-gray-700 d-flex position-relative item-hover__text">
                    <i className="ph ph-magnifying-glass" />
                  </span>
                </button>
                {/* Show wishlist only if user is authenticated */}
                {isAuthenticated && (
                  <Link to="/wishlist" className="flex-align gap-4 item-hover">
                    <span className="text-2xl text-gray-700 d-flex position-relative me-6 mt-6 item-hover__text">
                      <i className="ph ph-heart" />
                      <span className="w-16 h-16 flex-center rounded-circle bg-main-600 text-white text-xs position-absolute top-n6 end-n4">
                        {wishlistCount}
                      </span>
                    </span>
                    <span className="text-md text-gray-500 item-hover__text d-none d-lg-flex">
                      Wishlist
                    </span>
                  </Link>
                )}
                <Link to="/cart" className="flex-align gap-4 item-hover">
                  <span className="text-2xl text-gray-700 d-flex position-relative me-6 mt-6 item-hover__text">
                    <i className="ph ph-shopping-cart-simple" />
                    <span className="w-16 h-16 flex-center rounded-circle bg-main-600 text-white text-xs position-absolute top-n6 end-n4">
                      {cartCount}
                    </span>
                  </span>
                  <span className="text-md text-gray-500 item-hover__text d-none d-lg-flex">
                    Cart
                  </span>
                </Link>
              </div>
            </div>
            {/* Header Middle Right End  */}
          </nav>
        </div>
      </header>
      {/* ======================= Middle Header End ========================= */}
      {/* ==================== Header Start Here ==================== */}
      {/* <header
        className={`header bg-white border-bottom border-gray-100 ${
          scroll && "fixed-header"
        }`}
      > */}
      <header className="header bg-white border-bottom border-gray-100">
        <div className="container container-lg">
          <nav
            className="header-inner d-flex justify-content-between gap-8 mt-6"
            style={{ height: "45px" }}
          >
            <div className="flex-align menu-category-wrapper">
              {/* Category Dropdown Start */}
              <div className="category on-hover-item">
                {/* Original "All Categories" button (Hidden on mobile) */}
                <button
                  onClick={handleCategoryToggle}
                  type="button"
                  className="category__button flex-align gap-8 fw-medium p-5 border-end border-start border-gray-100 text-heading d-none d-md-flex"
                >
                  <span className="icon text-2xl">
                    <i className="ph ph-dots-nine" />
                  </span>
                  <span>All</span> Categories
                  <span className="arrow-icon text-xl d-flex">
                    <i className="ph ph-caret-down" />
                  </span>
                </button>

                {/* New Tile Icon Button (Only Visible on Mobile) */}
                <button
                  onClick={handleCategoryToggle}
                  type="button"
                  className="tile-icon-button p-16 d-flex d-md-none"
                >
                  <i className="ph ph-dots-nine" />
                </button>

                <div
                  className={`responsive-dropdown cat on-hover-dropdown common-dropdown nav-submenu p-0 submenus-submenu-wrapper ${
                    activeCategory && "active"
                  }`}
                >
                  <button
                    onClick={() => {
                      handleCategoryToggle();
                      setActiveIndexCat(null);
                    }}
                    type="button"
                    className="close-responsive-dropdown rounded-circle text-xl position-absolute inset-inline-end-0 inset-block-start-0 mt-4 me-8 d-lg-none d-flex"
                  >
                    {" "}
                    <i className="ph ph-x" />{" "}
                  </button>

                  {/* Logo Start */}

                  <ul className="scroll-sm p-0 py-8 w-300 max-h-400 overflow-y-auto">
                    {categories.map((category, index) => (
                      <li
                        key={category.id}
                        onMouseEnter={() =>
                          handleMouseEnter(index, category.id)
                        }
                        onMouseLeave={handleMouseLeave}
                        className={`has-submenus-submenu ${
                          activeIndexCat === index ? "active" : ""
                        }`}
                      >
                        <Link
                          onClick={() => setActiveIndexCat(null)}
                          to="#"
                          className="text-gray-500 text-15 py-12 px-16 flex-align gap-8 rounded-0"
                        >
                          {/* <span className="text-xl d-flex">
                            <i className="ph ph-carrot" />
                          </span> */}
                          <span>{category.name}</span>
                          <span className="icon text-md d-flex ms-auto">
                            <i className="ph ph-caret-right" />
                          </span>
                        </Link>

                        <div
                          className={`submenus-submenu py-16 ${
                            activeIndexCat === index ? "open" : ""
                          }`}
                        >
                          {/* <h6 className="text-lg px-16 submenus-submenu__title">
                            {category.name}
                          </h6> */}
                          <ul className="submenus-submenu__list max-h-300 overflow-y-auto scroll-sm">
                            {loading && activeIndexCat === index ? (
                              <li>Loading...</li>
                            ) : subCategories.length > 0 ? (
                              subCategories.map((subCategory) => (
                                <li key={subCategory.id}>
                                  <Link
                                    to={`/category-products/${subCategory.id}`}
                                  >
                                    {subCategory.name}
                                  </Link>
                                </li>
                              ))
                            ) : (
                              activeIndexCat === index && (
                                <li>No subcategories available</li>
                              )
                            )}
                          </ul>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="max-w-120 ms-16 d-flex d-md-none">
                <Link to="/" className="link">
                  <img src={Logo} alt="Logo" />
                </Link>
              </div>
              {/* Category Dropdown End  */}
              {/* Menu Start  */}
              <div className="header-menu d-lg-block d-none">
                {/* Nav Menu Start */}
                <ul className="nav-menu flex-align ">
                  <li className="nav-menu__item">
                    <NavLink
                      to="/"
                      className={(navData) =>
                        navData.isActive
                          ? "nav-menu__link activePage"
                          : "nav-menu__link"
                      }
                    >
                      Home
                    </NavLink>
                  </li>

                  {/* <li className="nav-menu__item">
                    <NavLink
                      to="/products"
                      className={(navData) =>
                        navData.isActive
                          ? "nav-menu__link activePage"
                          : "nav-menu__link"
                      }
                    >
                      Products
                    </NavLink>
                  </li> */}
                  <li className="nav-menu__item">
                    {hasCollections ? (
                      <div className="dropdown">
                        <a
                          className="nav-menu__link dropdown-toggle "
                          href="#"
                          id="productsDropdown"
                          role="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          Products
                        </a>
                        <ul
                          className="dropdown-menu"
                          aria-labelledby="productsDropdown"
                        >
                          {collections
                            .filter(
                              (collection) => collection.type !== "Hot_Deals"
                            )
                            .map((collection) => {
                              const collectionLink = `/${collection.type.toLowerCase()}/${
                                collection.collectionId
                              }`;
                              return (
                                <li key={collection.collectionId}>
                                  <NavLink
                                    to={collectionLink}
                                    className="dropdown-item"
                                  >
                                    {collection.displayName}
                                  </NavLink>
                                </li>
                              );
                            })}

                          <li>
                            <NavLink to="/products" className="dropdown-item">
                              All Products
                            </NavLink>
                          </li>
                        </ul>
                      </div>
                    ) : (
                      <NavLink
                        to="/products"
                        className={({ isActive }) =>
                          isActive
                            ? "nav-menu__link activePage"
                            : "nav-menu__link"
                        }
                      >
                        Products
                      </NavLink>
                    )}
                  </li>

                  {isAuthenticated ? (
                    <li className="nav-menu__item">
                      <NavLink
                        to="/my-orders"
                        className={(navData) =>
                          navData.isActive
                            ? "nav-menu__link activePage"
                            : "nav-menu__link"
                        }
                      >
                        My Orders
                      </NavLink>
                    </li>
                  ) : (
                    <li className="nav-menu__item">
                      <NavLink
                        to="/track-order"
                        className={(navData) =>
                          navData.isActive
                            ? "nav-menu__link activePage"
                            : "nav-menu__link"
                        }
                      >
                        Track Order
                      </NavLink>
                    </li>
                  )}

                  <li className="nav-menu__item">
                    <NavLink
                      to="/contact"
                      className={(navData) =>
                        navData.isActive
                          ? "nav-menu__link activePage"
                          : "nav-menu__link"
                      }
                    >
                      Contact Us
                    </NavLink>
                  </li>
                  <li className="on-hover-item nav-menu__item has-submenu">
                    {/* <span className="badge-notification bg-main-600 text-white text-sm py-2 px-8 rounded-4">
                      🔥
                    </span> */}
                    <ul className="submenu">
                      <li className="nav-menu__item">
                        <NavLink
                          to={
                            hotDealCollection
                              ? `/hotdeals/${hotDealCollection.collectionId}`
                              : "/hotdeals"
                          }
                          className={(navData) =>
                            navData.isActive
                              ? "nav-menu__link activePage"
                              : "nav-menu__link"
                          }
                        >
                          {hotDealCollection
                            ? hotDealCollection.displayName
                            : "Hot Deals"}
                        </NavLink>
                      </li>
                    </ul>
                  </li>
                </ul>
                {/* Nav Menu End */}
              </div>
              {/* Menu End  */}
            </div>
            {/* Header Right start */}
            <div
              className="header-right flex-align"
              // style={{ display: "none" }}
            >
              <Link
                to="tel:+94777961772"
                className="text-dark p-12 h-100 hover-bg-gray-50 flex-align gap-8 text-lg d-lg-flex d-none hover-text-main"
              >
                <div className="d-flex text-32">
                  <i className="ph ph-phone-call" />
                </div>
                (+94) 777961772
              </Link>
              <div className="me-16 d-lg-none d-block">
                <div className="flex-align flex-wrap gap-12">
                  <button
                    onClick={handleSearchToggle}
                    type="button"
                    className="search-icon flex-align d-lg-none d-flex gap-4 item-hover"
                  >
                    <span className="text-2xl text-gray-700 d-flex position-relative item-hover__text">
                      <i className="ph ph-magnifying-glass" />
                    </span>
                  </button>
                  {/* Show wishlist only if user is authenticated */}
                  {isAuthenticated && (
                    <Link
                      to="/wishlist"
                      className="flex-align gap-4 item-hover"
                    >
                      <span className="text-2xl text-gray-700 d-flex position-relative me-6 mt-6 item-hover__text">
                        <i className="ph ph-heart" />
                        <span className="w-16 h-16 flex-center rounded-circle bg-main-600 text-white text-xs position-absolute top-n6 end-n4">
                          {wishlistCount}
                        </span>
                      </span>
                      <span className="text-md text-gray-500 item-hover__text d-none d-lg-flex">
                        Wishlist
                      </span>
                    </Link>
                  )}
                  <Link to="/cart" className="flex-align gap-4 item-hover">
                    <span className="text-2xl text-gray-700 d-flex position-relative me-6 mt-6 item-hover__text">
                      <i className="ph ph-shopping-cart-simple" />
                      <span className="w-16 h-16 flex-center rounded-circle bg-main-600 text-white text-xs position-absolute top-n6 end-n4">
                        {cartCount}
                      </span>
                    </span>
                    <span className="text-md text-gray-500 item-hover__text d-none d-lg-flex">
                      Cart
                    </span>
                  </Link>
                </div>
              </div>
              <button
                onClick={handleMenuToggle}
                type="button"
                className="toggle-mobileMenu d-lg-none ms-3n text-gray-800 text-4xl d-flex"
              >
                {" "}
                <i className="ph ph-list" />{" "}
              </button>
            </div>
            {/* Header Right End  */}
          </nav>
        </div>
        {/* Mobile Bottom Navigation - Visible Only on Mobile */}
      </header>
      {/* ==================== Header End Here ==================== */}
      <MobileViewBottomNav />
      {isModalOpen && <AppModal onClose={handleModalClose} />}
    </>
  );
};

export default HeaderOne;
